export default "__VITE_ASSET__DQFl_6UW__"